import { SwalError } from './mySwal'

/**
 * פותח את בורר אנשי הקשר של הדפדפן.
 * @param {string[]} properties - המאפיינים לבקש (למשל, ['name', 'email', 'tel']).
 * @param {object} options - אופציות נוספות (למשל, { multiple: false }).
 * @returns {Promise<Contact|null>} - מחזיר את איש הקשר שנבחר, או null במקרה של שגיאה או ביטול.
 */
export const pickContact = async (
  properties = ['name', 'email', 'tel', 'address'],
  options = { multiple: false }
) => {
  // בדיקה אם הדפדפן תומך, ואם לא - במצב פיתוח מחזיר דמה
  const isDev = import.meta.env.MODE === 'development'

  if (!('contacts' in navigator && 'select' in navigator.contacts)) {
    if (isDev) {
      console.log('🚀 ~ contacts.js:18 ~ isDev:', isDev)

      // דמו איש קשר במצב פיתוח
      return {
        name: ['משה כהן'],
        email: ['moshe@example.com'],
        tel: ['050-1234567'],
        address: ['רחוב הדגמה 1, תל אביב']
      }
    }
    const errorMessage = 'מצטערים, הדפדפן שלך אינו תומך בבחירת אנשי קשר.'
    SwalError.fire(errorMessage)
    return null
  }

  try {
    const contacts = await navigator.contacts.select(properties, options)
    if (contacts.length === 0) {
      return null // המשתמש סגר את הבוחר
    }
    return contacts[0]
  } catch (ex) {
    console.error('שגיאה בבחירת איש קשר:', ex)
    const errorMessage = 'אירעה שגיאה בעת ניסיון הגישה לאנשי הקשר.'
    SwalError.fire(errorMessage)
    return null
  }
}
